// Cambiar el lugar del evento (Logística 2). El lugar se enseña una sola vez,
// en la línea "Dónde" del resumen; esto es el editor que se abre con su
// "Cambiar" (o solo, si falta el lugar o la ruta): buscador de Google y
// "Calcular ruta". Mismos manejadores que la pestaña Logística.
import React from 'react';
import DireccionAutocomplete from '../../DireccionAutocomplete';
import { botonSecundario, enlace, enlacePequeno } from './estilos';
import { TEXTO_SIN_RUTA, avisoRutaPresupuesto } from '../../../utils/tareasPresupuesto';

const LugarEvento2 = ({
  presupuesto, onCambiarLugar, onSeleccionarLugar, onCalcularRuta, calculandoRuta = false, onCerrar = null,
}) => {
  const p = presupuesto || {};
  // Sin ruta, ruta de otra dirección o Google no la encontró (U-02: ya no se
  // calcula sola al abrir la ficha)
  const avisoRuta = avisoRutaPresupuesto(p) || (!p.distancia_km && !!p.lugar_evento ? TEXTO_SIN_RUTA : null);
  const faltaRuta = !!avisoRuta;

  const textoPendiente = calculandoRuta ? 'Calculando la ruta desde la nave...' : avisoRuta;

  return (
    <div className="flex flex-col gap-2 rounded-lg border border-[#E1E6E3] px-3.5 py-3" data-testid="l2-lugar-editor">
      <label htmlFor="l2-direccion" className="text-xs font-semibold text-[#5B6B64]">Lugar o dirección del evento</label>
      <DireccionAutocomplete
        id="l2-direccion"
        value={p.lugar_evento || ''}
        onChange={onCambiarLugar}
        onSelect={onSeleccionarLugar}
        placeholder="Busca el lugar o la dirección..."
        className="w-full px-3 py-2 text-sm border border-[#CBD3CF] rounded-lg focus:outline-none focus:ring-2 focus:ring-duetto-primary"
      />
      {p.direccion_exacta && p.direccion_exacta !== p.lugar_evento && (
        <p className="text-xs text-[#5B6B64]" data-testid="l2-lugar-direccion">Dirección de Google: {p.direccion_exacta}</p>
      )}
      {faltaRuta && (
        <div className="flex flex-wrap items-center justify-between gap-3 rounded-[10px] border px-3.5 py-2.5 text-sm bg-[#FDF0DC] border-[#F4D9AE] text-[#7A3A06]" data-testid="l2-lugar-ruta-pendiente">
          <span>{textoPendiente}</span>
          {!calculandoRuta && onCalcularRuta && (
            <button type="button" onClick={() => onCalcularRuta(true)} className={botonSecundario} data-testid="l2-lugar-calcular-ruta">
              Calcular ruta
            </button>
          )}
        </div>
      )}
      <div className="flex flex-wrap items-center gap-4">
        {!faltaRuta && p.lugar_evento && onCalcularRuta && (
          <button type="button" onClick={() => onCalcularRuta(true)} disabled={calculandoRuta} className={enlacePequeno} data-testid="l2-lugar-recalcular">
            {calculandoRuta ? 'Calculando...' : 'Volver a calcular la ruta'}
          </button>
        )}
        {onCerrar && (
          <button type="button" onClick={onCerrar} className={enlace} data-testid="l2-lugar-cerrar">Listo</button>
        )}
      </div>
    </div>
  );
};

export default LugarEvento2;
